import {
    GET_APPROVAL_GROUP,
    GET_APPROVAL_ROUTES,
    GET_PAYMENT_APPROVAL_ROUTE,
    GET_APPROVAL_ROUTE_ENTITY
} from "../types/approvalType";

const initialState = {
    approvalGroups: [],
    approvalRoutes: [],
    paymentApprovalRoutes: [],
    approvalRouteEntities: []
};

const approvalReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_APPROVAL_GROUP:
            return {
                ...state,
                approvalGroups: payload
            };
        case GET_APPROVAL_ROUTES:
            return {
                ...state,
                approvalRoutes: payload
            };
        case GET_PAYMENT_APPROVAL_ROUTE:
            return {
                ...state,
                paymentApprovalRoutes: payload
            };
        case GET_APPROVAL_ROUTE_ENTITY:
            return {
                ...state,
                approvalRouteEntities: payload
            };

        default:
            return state;
    }
};

export default approvalReducer;
